<template>
    <nav class="navbar" role="navigation" aria-label="main navigation">
        <div id="usernav" class="lb-top-menu is-active" @click="toggleMenu">
            <div class="navbar-item has-dropdown">
                <a class="navbar-link is-arrowless py-3 is-size-6">
                    <span>{{ routeName }}</span>
                    <span class="icon is-small pl-3">
                        <i class="fas fa-angle-down" aria-hidden="true"></i>
                    </span>
                </a>

                <div
                    :class="{ 'is-hidden': !dropdownActive }"
                    class="navbar-dropdown has-background-white floating pt-0"
                >
                    <router-link
                        v-t="'Dashboard.projects'"
                        :to="{
                            path: '/dashboard',
                            query: {
                                filter: 'mine',
                            },
                        }"
                        class="
                            navbar-item
                            has-text-weight-bold has-text-black
                            py-3
                            is-size-6
                        "
                    ></router-link>
                    <hr class="navbar-divider has-background-very-light-pink" />
                    <router-link
                        v-t="'Dashboard.mine'"
                        :to="{
                            path: '/dashboard',
                            query: {
                                filter: 'mine',
                            },
                        }"
                        class="navbar-item dashed py-3 is-size-6"
                        exact
                    />
                    <hr class="navbar-divider has-background-very-light-pink" />
                    <router-link
                        v-if="hasSchool"
                        v-t="'Dashboard.my_school_projects'"
                        :to="{
                            path: '/dashboard',
                            query: {
                                filter: 'mySchool',
                            },
                        }"
                        class="navbar-item dashed py-3 is-size-6"
                        exact
                    />
                    <hr class="navbar-divider has-background-very-light-pink" />
                    <router-link
                        v-t="'Dashboard.other_users'"
                        :to="{
                            path: '/dashboard',
                            query: {
                                filter: 'invited',
                            },
                        }"
                        class="navbar-item dashed py-3 is-size-6"
                        exact
                    />
                    <hr class="navbar-divider has-background-very-light-pink" />
                    <p
                        v-if="$store.getters.isTeacher"
                        class="
                            is-capitalized
                            has-text-weight-bold has-text-black
                            is-size-6
                            py-2
                        "
                    >
                        {{ $store.getters.school.name }}
                    </p>
                    <hr class="navbar-divider has-background-very-light-pink" />
                    <router-link
                        v-t="'Dashboard.school'"
                        :to="{ name: 'school' }"
                        class="navbar-item dashed py-3 is-size-6"
                        tag="a"
                    ></router-link>
                    <hr class="navbar-divider has-background-very-light-pink" />
                    <router-link
                        v-t="'Dashboard.groups'"
                        :to="{ name: 'groups' }"
                        tag="a"
                        class="navbar-item dashed py-3 is-size-6"
                    ></router-link>
                    <hr class="navbar-divider has-background-very-light-pink" />
                    <router-link
                        v-t="'Dashboard.sessions'"
                        :to="{
                            path: '/dashboard',
                        }"
                        class="
                            navbar-item
                            has-text-weight-bold has-text-black
                            py-3
                            is-size-6
                        "
                        exact
                    />
                    <hr class="navbar-divider has-background-very-light-pink" />
                    <router-link
                        v-t="'Dashboard.mySessions'"
                        :to="{
                            path: '/dashboard/sessions',
                            query: {
                                filter: 'mine',
                            },
                        }"
                        tag="a"
                        class="navbar-item dashed py-3 is-size-6"
                    ></router-link>
                    <hr class="navbar-divider has-background-very-light-pink" />
                    <router-link
                        v-t="'Dashboard.playedSessions'"
                        :to="{
                            path: '/dashboard/sessions',
                            query: {
                                filter: 'played',
                            },
                        }"
                        class="navbar-item dashed py-3 is-size-6"
                        exact
                    ></router-link>

                    <hr class="navbar-divider has-background-very-light-pink" />
                    <router-link
                        v-t="'Dashboard.communities'"
                        :to="{
                            path: '/dashboard',
                        }"
                        class="
                            navbar-item
                            has-text-weight-bold has-text-black
                            py-3
                            is-size-6
                        "
                        exact
                    />
                    <hr class="navbar-divider has-background-very-light-pink" />
                    <router-link
                        v-if="hasCommunities"
                        v-t="'Dashboard.my_communities'"
                        :to="{ name: 'communities' }"
                        exact
                        tag="a"
                        class="navbar-item dashed py-3 is-size-6"
                    ></router-link>
                    <!--router-link
            v-t="'Dashboard.other_communities'"
            :to="{ name: 'communities-explorer' }"
            class="navbar-item dashed py-3 is-size-6"
            exact
            tag="a"
          >
                    </router-link-->
                </div>
            </div>
        </div>
    </nav>
</template>

<script>
export default {
    props: {},
    data() {
        return {
            dropdownActive: false,
        };
    },
    computed: {
        hasSchool() {
            return this.$store.getters.hasSchool;
        },
        hasCommunities() {
            return this.$store.getters.hasCommunities;
        },
        routeName() {
            if (this.$route.query.filter)
                return this.$t('Dashboard.' + this.$route.query.filter);
            else {
                return this.$t('Dashboard.' + this.$route.name);
            }
        },
    },
    methods: {
        toggleMenu() {
            this.dropdownActive = !this.dropdownActive;
        },
    },
};
</script>

<style scoped lang="sass">
.floating
    position: absolute
    width: 100%
    top: 0

#usernav .navbar-divider
    display: block
    width: 85%
    margin: 0 auto
    height: 1px

#usernav .navbar-link.is-arrowless .icon
    vertical-align: middle
</style>
